import axios from "axios";
import { Ref, ref } from "vue";
import {
  TeamCurrentAndPendingMembersApiModel,
  TeamCurrentMemberApiModel,
  UserProfileApiModel,
} from "../api-models";

type UseTeamMembers = {
  teamMembers: Ref<TeamCurrentAndPendingMembersApiModel | undefined>;
  error: Ref<string | undefined>;
  fetchUserProfiles: (members: TeamCurrentMemberApiModel[]) => Promise<UserProfileApiModel[]>;
};
async function getTeamMembers(teamId: string): Promise<TeamCurrentAndPendingMembersApiModel> {
  const response = await axios.get(`/api/teammembership/${teamId}`);
  return response.data as TeamCurrentAndPendingMembersApiModel;
}

async function fetchUserProfiles(members: TeamCurrentMemberApiModel[]) {
  const requests = members.map((member) => {
    return axios.get<UserProfileApiModel>(`/api/UserProfile/${member.userDetails.id}`);
  });

  try {
    const responses = await Promise.all(requests);
    return responses.map((response) => response.data);
  } catch (err) {
    return []; // Return an empty array or handle the error as needed
  }
}

function useTeamMembers(teamId: string): UseTeamMembers {
  const teamMembers = ref<TeamCurrentAndPendingMembersApiModel>();
  const error = ref<string>();

  getTeamMembers(teamId)
    .then((members) => {
      teamMembers.value = members;
    })
    .catch((e) => {
      error.value = e.message ?? "There was an error getting the team members";
    });

  return {
    teamMembers,
    error,
    fetchUserProfiles,
  };
}

export default useTeamMembers;
